"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deduplicateErrorDatas = exports.isSrcElement = exports.isLinkElement = exports.getLoadSpeed = exports.processResourceData = exports.getResourceType = exports.getFileType = exports.supportObserveType = exports.isResource = void 0;
var constants_1 = require("./constants");
var isResource = function (entry) { return entry.entryType === 'resource'; };
exports.isResource = isResource;
var supportObserveType = function (type) { var _a, _b; return (_b = (_a = window.PerformanceObserver) === null || _a === void 0 ? void 0 : _a.supportedEntryTypes) === null || _b === void 0 ? void 0 : _b.includes(type); };
exports.supportObserveType = supportObserveType;
var getFileType = function (url) {
    var _a;
    return (_a = url.match(/\.(\w{2,5})$/)) === null || _a === void 0 ? void 0 : _a[1];
};
exports.getFileType = getFileType;
var getResourceType = function (src, initiatorType) {
    if (constants_1.SupportInitiatorType.includes(initiatorType)) {
        var resourceType = constants_1.initiatorTypeMap[initiatorType];
        if (resourceType) {
            return resourceType;
        }
    }
    var fileType = exports.getFileType(src);
    for (var _i = 0, _a = Object.keys(constants_1.resourceTypeMap); _i < _a.length; _i++) {
        var type = _a[_i];
        var rule = constants_1.resourceTypeMap[type];
        if (fileType === null || fileType === void 0 ? void 0 : fileType.match(rule)) {
            return type;
        }
    }
    return undefined;
};
exports.getResourceType = getResourceType;
var isStringProperty = function (key) { return ['initiator_type', 'next_hop_protocol'].includes(key); };
/** 预处理resource数据 */
var processResourceData = function (entry) {
    var _a, _b;
    var result = {};
    for (var _i = 0, resourceTimingKeys_1 = constants_1.resourceTimingKeys; _i < resourceTimingKeys_1.length; _i++) {
        var key = resourceTimingKeys_1[_i];
        // convert into camelCase
        var entryKey = key.replace(/_([a-z])/g, function () {
            var match = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                match[_i] = arguments[_i];
            }
            return match[1].toLocaleUpperCase();
        });
        if (isStringProperty(key)) {
            result[key] = entry[entryKey] || constants_1.UNKNOWN;
        }
        else {
            result[key] = entry[entryKey] >= 0 ? Math.round(entry[entryKey]) : -1;
        }
    }
    result.time_origin = Math.round((_b = (_a = performance.timeOrigin) !== null && _a !== void 0 ? _a : performance.timing.navigationStart) !== null && _b !== void 0 ? _b : -1);
    result = oversizeLimiter(result);
    return result;
};
exports.processResourceData = processResourceData;
var oversizeLimiter = function (entry) {
    var obj = __assign({}, entry);
    if (entry.encoded_body_size) {
        // js 大整数有精度丢失，因此和 BE 同步后确认超过最大值给 -1
        if (entry.encoded_body_size > constants_1.INT_MAX) {
            obj.encoded_body_size = constants_1.OVERFLOW_VALUE;
            obj.overflow = true;
        }
    }
    return obj;
};
// KiB per second - 保留两位小数
var getLoadSpeed = function (entry) {
    var supportSpeed = 'transferSize' in entry && 'duration' in entry && entry.transferSize > 0 && entry.duration > 0;
    if (!supportSpeed) {
        return -1;
    }
    return Math.round(entry.transferSize / entry.duration / 10.24) / 100;
};
exports.getLoadSpeed = getLoadSpeed;
var isLinkElement = function (target) { return target.localName === 'link'; };
exports.isLinkElement = isLinkElement;
var isSrcElement = function (target) { return constants_1.SupportInitiatorType.includes(target.localName); };
exports.isSrcElement = isSrcElement;
/**
 * https://stackoverflow.com/questions/45710295/new-image-src-same-url-coding-twice-but-the-browser-just-can-catch-one-reque
 */
var deduplicateErrorDatas = function (datas) {
    if (!constants_1.supportGetEntriesByType) {
        return datas;
    }
    var obtainedResources = performance.getEntriesByType('resource');
    var result = [];
    var _loop_1 = function (data) {
        var identicalResources = result.filter(function (item) { return item.src === data.src && Math.abs(item.timeStamp - data.timeStamp) < constants_1.ERROR_RESOURCE_DUPLICATE_TIMELIMIT; });
        // check 
        var identicalObtainedResources = obtainedResources.filter(function (entry) { return entry.name === data.src; });
        if (identicalObtainedResources.length === 0) {
            // should patch
            data.shouldPatch = true;
        }
        var shouldReportData = !identicalResources.length || identicalResources.length < identicalObtainedResources.length;
        if (shouldReportData) {
            result.push(data);
        }
    };
    for (var _i = 0, datas_1 = datas; _i < datas_1.length; _i++) {
        var data = datas_1[_i];
        _loop_1(data);
    }
    return result;
};
exports.deduplicateErrorDatas = deduplicateErrorDatas;
